import React, { useState } from "react";
import "./styles.scss";
import { Modal } from "react-bootstrap";
import OutlineCirclePlusIcon from "../../../../shared/Svg/OutlineCirclePlusIcon";
import Input from "../Input";

function FeatureArtist(props) {
  const [isModalVisible, setModalVisibility] = useState(false);
  const [artistName, setArtistName] = useState("");
  const [featureArtistLists, setFeatureList] = useState(props.feature);

  const hideModal = () => {
    setModalVisibility(false);
  };
  const showModal = () => {
    setModalVisibility(true);
  };

  const onTextChange = (e) => {
    setArtistName(e.target.value);
  };

  const addNewArtistName = () => {
    const updatedList = [...featureArtistLists, artistName];
    setFeatureList(updatedList);
    props.onAddNewArtist(updatedList);
    hideModal();
    setArtistName("");
  };

  return (
    <div className="d-flex text-dark bold mt-3 artist-feature">
      <label className="mr-3 mb-0"> Featured Artists: </label>
      <div className="d-flex flex-row flex-wrap">
        {featureArtistLists && featureArtistLists.map((artist) => <span className="artist">{artist}</span>)}
        <OutlineCirclePlusIcon style={{ cursor: "pointer" }} color="#01a0c6" onClick={showModal} />
      </div>
      <Modal id="feature-artist-modal" show={isModalVisible} onHide={hideModal}>
        <Modal.Body>
          <div className="p-3 text-center">
            <p className="font-weight-bold mb-3 text-uppercase">Please enter an artist name you want to feature</p>
            <Input
              placeholder="Artist name"
              label="Artist name"
              type="text"
              value={artistName}
              name="artistName"
              lablePosition="top"
              onChange={onTextChange}
            />
            <div className="d-flex justify-content-center">
              <button disabled={!artistName} onClick={addNewArtistName} className="text-uppercase btn btn-md btn-outline-primary mr-4">
                Add
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}
export default FeatureArtist;
